import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../../components/ui/card';

const ComplianceConfigCard = ({ productionStatus }) => {
  return (
    <Card className="glass-card border-white/20">
      <CardHeader>
        <CardTitle>Compliance Configuration</CardTitle>
        <CardDescription className="mt-1">Current enforcement settings</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div className="p-4 rounded-lg bg-secondary/50">
            <div className="text-sm font-medium mb-2">Call Frequency Caps</div>
            <div className="space-y-1">
              <div className="flex justify-between text-xs">
                <span className="text-muted-foreground">Per Day:</span>
                <span className="font-semibold">2 calls</span>
              </div>
              <div className="flex justify-between text-xs">
                <span className="text-muted-foreground">Per Week:</span>
                <span className="font-semibold">3 calls</span>
              </div>
            </div>
          </div>

          <div className="p-4 rounded-lg bg-secondary/50">
            <div className="text-sm font-medium mb-2">DNC List Refresh</div>
            <div className="space-y-1">
              <div className="flex justify-between text-xs">
                <span className="text-muted-foreground">Frequency:</span>
                <span className="font-semibold">Every 24 hours</span>
              </div>
            </div>
          </div>

          <div className="p-4 rounded-lg bg-secondary/50">
            <div className="text-sm font-medium mb-2">Recording Settings</div>
            <div className="space-y-1">
              <div className="flex justify-between text-xs">
                <span className="text-muted-foreground">Recording:</span>
                <span className="font-semibold text-success">Enabled</span>
              </div>
              <div className="flex justify-between text-xs">
                <span className="text-muted-foreground">Announcement:</span>
                <span className="font-semibold text-muted-foreground">Disabled</span>
              </div>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default ComplianceConfigCard;
